import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  mergeDeepLeft,
  clone,
  path,
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Input from '../../common/Input';
import TextArea from '../../common/TextArea';
import Currency from '../../common/Currency';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import '../../css/forms/default-forms.css';
import { fields } from './fields';
import { processFields } from '../../utils/prePost';
import { validateFields } from '../../utils/validate';
import { addMaterial } from '../../api/materials';
import { getVendorsList } from '../../api/vendors';

export class MaterialAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: clone(fields),
    };
    this.submit = this.submit.bind(this);
    this.cancel = this.cancel.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      const processedData = processFields(this.state.fields);
      this.props.saveForm(processedData);
    }
    return false;
  }

  cancel() {
    this.props.redirectToMaterials();
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  componentDidMount() {
    this.props.getVendors();
  }

  getVendorsOptions() {
    const vendorsList = path(['vendors', 'list'], this.props) || [];
    return vendorsList.map((vendor) => ({
      value: vendor.id,
      label: vendor.name,
    }));
  }

  render() {
    return (
      <div>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/materials', icon: 'shopping_cart', name: 'Materials' },
          { icon: 'add_to_photos', name: 'Add Material' },
        ]} />
        <div className="card rounded">
          <div className="card-header rounded-top">
            <b>Add Material</b>
          </div>
          <div className="card-block">
            <div className="col" style={{ paddingBottom: '40px' }}>
              <button className={'btn btn-danger btn-outline pull-right ml-3'} onClick={this.cancel}>
                <i className="fa fa-remove"></i>
                <span className="pl-1">Cancel</span>
              </button>
              <button className={'btn btn-success btn-outline pull-right'} onClick={this.submit}>
                <i className="fa fa-check"></i>
                <span className="pl-1">Save & Continue</span>
              </button>
            </div>

            <form onSubmit={this.submit}>
              <div className="col-12">
                <Input
                  field={this.state.fields['sku']}
                  onChange={this.changeFormValue}
                />
                <Input
                  field={this.state.fields['name']}
                  onChange={this.changeFormValue}
                />
                <Currency
                  field={this.state.fields['cost']}
                  onChange={this.changeFormValue}
                />
                <Currency
                  field={this.state.fields['price']}
                  onChange={this.changeFormValue}
                />
                <ReactSelectWrapper
                  options={this.getVendorsOptions()}
                  field={this.state.fields['vendor']}
                  onChange={this.changeFormValue}
                />
                <Input
                  field={this.state.fields['unit_of_measure']}
                  onChange={this.changeFormValue}
                />
                <TextArea
                  field={this.state.fields['notes']}
                  onChange={this.changeFormValue}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    redirectToMaterials: () => {
      dispatch(push('/pages/materials'));
    },
    saveForm: (data) => {
      addMaterial(data)(dispatch);
    },
    getVendors: () => {
      getVendorsList()(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialAdd);



// WEBPACK FOOTER //
// ./src/containers/MaterialAdd/index.js